<fr-table [config]="tenantsTableConfig" [data]="tenants" Id="tenants-table" [paginatorConfig]="paginatorConfig">
</fr-table>
<div class="table-sub-header" above-table-body-space>
  <app-loading-spinner *ngIf="!tenants"></app-loading-spinner>
</div>